// Base URL of the patient dashboard app (where the public /choose-a-bundle page
// lives). Overridable for non-prod via VITE_DASHBOARD_URL; mirrors the helper in
// src/helpers/*-schedule.ts.
export function getDashboardBaseUrl(): string {
  const raw = (import.meta.env.VITE_DASHBOARD_URL as string | undefined)?.trim();
  const base = raw && raw.length > 0 ? raw : "https://dashboard.rockethealth.app";
  return base.endsWith("/") ? base.slice(0, -1) : base;
}

// v2 booking link: the patient dashboard product page for a specific bundle usage
// (`/product/<product_id>?usage_id=<usage_id>`). This is the v2 equivalent of the
// legacy "Copy Schedule Link" — the dashboard resolves the bookable sessions for
// that usage.
export function buildV2ProductBookingLink(
  productId: string,
  usageId: string,
): string {
  const params = new URLSearchParams({ usage_id: usageId });
  return `${getDashboardBaseUrl()}/product/${productId}?${params.toString()}`;
}
